import ActionKargoDetail from "../components/PatientDetail/Action/ActionKargoDetail";

export default function ActionKargo(props) {
  return (
    <div className="mx-2">
      <ActionKargoDetail {...props} />
    </div>
  );
}
